import { render } from "./Moban.vue?vue&type=template&id=a7eafb58&scoped=true"
import script from "./Moban.vue?vue&type=script&lang=js"
export * from "./Moban.vue?vue&type=script&lang=js"

import "./Moban.vue?vue&type=style&index=0&id=a7eafb58&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7eafb58"]])

export default __exports__